import { ComponentNameEnum } from '@/types';

export interface GamePrizesEditorOptions {
  showColorPicker?: boolean;
  defaultValue?: string;
}

const getGamePrizesEditorFieldConfig = (options: GamePrizesEditorOptions = {}) => ({
  componentName: ComponentNameEnum.GAME_PRIZES_EDITOR,
  options: {
    showColorPicker: options.showColorPicker ?? false,
    defaultValue: options.defaultValue ?? '[]',
  },
});

export default getGamePrizesEditorFieldConfig;
